import { render, staticRenderFns } from "./projectCard.vue?vue&type=template&id=83d8962c&"
import script from "./projectCard.vue?vue&type=script&lang=js&"
export * from "./projectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports